import { getEmployeeName } from "../../../auth/utils/Login/authStorage";
import { useDashboardDate } from "../../context/DashboardDateContext";

interface Props {
  header: {
    todayProductivity: number;
    aboveTarget: number;
    target: number;
    businessUnit: string;
  };
}

const ProductivityHeader = ({ header }: Props) => {
  const employeeName = getEmployeeName() || "Me";

  const { fromDate } = useDashboardDate();

  const getDateLabel = () => {
    if (!fromDate) {
      return "Today";
    }

    const selectedDate = new Date(fromDate);

    // Remove time portion
    selectedDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Today
    if (selectedDate.getTime() === today.getTime()) {
      return "Today";
    }

    // Yesterday
    if (selectedDate.getTime() === yesterday.getTime()) {
      return "Yesterday";
    }

    // Other date
    return selectedDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <h2 className="text-[16px] font-semibold text-[#002B5B]">
        Productivity · {getDateLabel()} {header.todayProductivity}%
      </h2>

      <div className="rounded-full bg-[#EAF2FF] px-3 py-[5px] text-[12px] font-medium text-[#2563EB]">
        {employeeName} ·{" "}
        {header.aboveTarget >= 0 ? "+" : ""}
        {header.aboveTarget}pp above {header.target}% target ·{" "}
        {header.businessUnit}
      </div>
    </div>
  );
};

export default ProductivityHeader;